// Aquí están los thunks relacionados con el registro de usuarios
import { createAsyncThunk } from "@reduxjs/toolkit";
import store from "@/app/store";
import api from "@/services/api";
import {
  seguidoresSuccess,
  seguidoresFailure,
  seguidoresReset,
} from "./seguidoresSlice";

/**
 * 📝 SEGUIDORES — Obtiene los seguidores de un usuario
 */
export const getSeguidores = createAsyncThunk(
  "seguidores/getSeguidores",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const state = store.getState();
      const uid = state.auth.user?.uid;
      
      if (!uid) {
        throw new Error("UID de usuario no disponible");
      }
      const { data } = await api.get(`/seguidores/${uid}`);
      
      dispatch(seguidoresSuccess({ seguidoresInfo: data }));
      return data;
    } catch (err) {
      console.error("Error al obtener seguidores:", err);
      dispatch(
        seguidoresFailure(
          err.response?.data ||
            err.response?.data?.message ||
            "Error de seguidores"
        )
      );
      return rejectWithValue(
        err.response?.data ||
          err.response?.data?.message ||
          "Error de seguidores"
      );
    }
  }
);
